/* @flow */

import * as React from 'react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import { Roles } from 'permissions/defs';
import type { RoleId } from 'permissions/defs';

//----------------------------------------------------------------------//
// CSS                                                                  //
//----------------------------------------------------------------------//

import styles from './UserRole.module.scss';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

type TypeProps = {|
  current: RoleId,
  showDescription?: boolean,
|} & TranslatorProps;

function UserRole({ t, current, showDescription }: TypeProps) {
  const roles = [
    {
      id: 5,
      name: Roles.ACCOUNT_ADMIN,
      label: 'Account Admin',
      description: `Overall control of the online account, plus assignment
                and management of users. View of all information.`,
    },
    {
      id: 2,
      name: Roles.MANAGER,
      label: 'Manager',
      description: `Oversight over Users (engineers) with view and ability
                to manage and allocate all equipment, projects and costs centers,
                except financial approvals.`,
    },
    {
      id: 1,
      name: Roles.USER,
      label: 'User',
      description: `Typically an engineer with view of all equipment and
                ability to make requests for approval by others; including a view
                of projects where assigned.`,
    },
    {
      id: 3,
      name: Roles.PURCHASER,
      label: 'Purchaser',
      description: `View and ability to manage and allocate all equipment,
                projects and costs centers, and approve purchases.`,
    },
    {
      id: 4,
      name: Roles.VIEW_ONLY,
      label: 'Executive',
      description: 'Access for view only including summary dashboards.',
    },
  ];

  //console.log('currentcurrentcurrent', current);

  return (
    <React.Fragment>
      <ul className={styles.roleList}>
        {roles.map((role: Object, index: number) => (
          <li key={index.toString()} className={current === role.name ? styles.active : ''}>
            <span className={styles.roleListHeading}>
              <span className={styles.roleListIcon}>
                <svg>
                  <use xlinkHref="#icon-profile" />
                </svg>
              </span>
              <span>
                <h5>{t(`${role.label}`)}</h5>
              </span>
            </span>
            {showDescription && (
              <p className={styles.roleListDescription}>{t(`${role.description}`)}</p>
            )}
          </li>
        ))}
      </ul>
    </React.Fragment>
  );
}

export default translate()(UserRole);
